export default function segments(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                segment: action.segment,
            }
        default:
            return state;
    }
}
